import { ReportingEventNumberDto } from '@mark43/cad-api';
import { Stack, DataList, DataItem } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { DispatchSection } from '../../../../../panels/entity-panels/tabs/dispatch-section';
import { RenDetails } from '../helpers/ren-details';
import { formatMonthDayYearHoursMinutes } from '../../../../../common/helpers/utils';
import { useEventMetadataStore } from '../../../../event-panel-form/event-metadata';
import { useWorkspacePanel } from '../../../../../panels/hooks/use-workspace-panel';

export const EventDetailsSection = observer(function EventDetailsSection(props: {
    isExternal: boolean;
    reportingEventNumbers: ReportingEventNumberDto[];
    agencyId: number;
    dispatcher?: string;
    callTaker?: string;
    isScheduled: boolean;
}): React.ReactElement {
    const { agencyEventNumber, scheduledEventScheduledDateUtc, scheduledEventFrequencyType } =
        useEventMetadataStore().state.metadata ?? {};
    const eventId = useWorkspacePanel().linkedEntityId;

    return (
        <TabSection>
            <Stack>
                {props.isScheduled ? (
                    <DataList>
                        <DataItem dataKey="Scheduled Event #">{agencyEventNumber}</DataItem>
                        <DataItem dataKey="Next Scheduled Date/Time">
                            {scheduledEventScheduledDateUtc
                                ? formatMonthDayYearHoursMinutes(scheduledEventScheduledDateUtc)
                                : undefined}
                        </DataItem>
                        <DataItem dataKey="Frequency">{scheduledEventFrequencyType}</DataItem>
                    </DataList>
                ) : (
                    <Stack>
                        <DataList>
                            <DataItem dataKey="Event #">{agencyEventNumber}</DataItem>
                        </DataList>
                        {!props.isExternal && (
                            <RenDetails
                                eventId={eventId}
                                reportingEventNumbers={props.reportingEventNumbers}
                                agencyId={props.agencyId}
                            />
                        )}
                    </Stack>
                )}

                <DispatchSection dispatcher={props.dispatcher} callTaker={props.callTaker} />
            </Stack>
        </TabSection>
    );
});
